module.exports = __webpack_public_path__ + "static/transactionalemail-punctuation-dont-fd5ce3c0f0879f5f16882a15f3ec05cc.png";